import scripts from '@swipekit/lib/scripts';

const brandTrackerIcon = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 7.19956C14.9554 6.44633 13.657 6 12.25 6C8.79822 6 6 8.68629 6 12C6 15.3137 8.79822 18 12.25 18C13.657 18 14.9554 17.5537 16 16.8004M17.8667 20.0007C16.2093 21.2561 14.1491 22 11.9167 22C6.43984 22 2 17.5228 2 12C2 6.47715 6.43984 2 11.9167 2C14.1491 2 16.2093 2.74389 17.8667 3.99927C18.2444 4.25877 18.5 4.5 18.5 5M14 10L20.5 3.5M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"/></svg>`;
const swipefileIcon = `<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M20.255 17.05V10.35C20.255 9.78995 20.255 9.50992 20.146 9.29601C20.0501 9.10785 19.8972 8.95487 19.709 8.85899C19.4951 8.75 19.2151 8.75 18.655 8.75H5.35C4.78995 8.75 4.50992 8.75 4.29601 8.85899C4.10785 8.95487 3.95487 9.10785 3.85899 9.29601C3.75 9.50992 3.75 9.78995 3.75 10.35V17.05C3.75 18.1701 3.75 18.7302 3.96799 19.158C4.15973 19.5343 4.46569 19.8403 4.84202 20.032C5.26984 20.25 5.82989 20.25 6.95 20.25H17.055C18.1751 20.25 18.7352 20.25 19.163 20.032C19.5393 19.8403 19.8453 19.5343 20.037 19.158C20.255 18.7302 20.255 18.1701 20.255 17.05Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.75 8V3.75C5.75 3.19772 6.19772 2.75 6.75 2.75H9.67157C10.202 2.75 10.7107 2.96071 11.0858 3.33579L12.2071 4.45711C12.3946 4.64464 12.649 4.75 12.9142 4.75H17.25C17.8023 4.75 18.25 5.19772 18.25 5.75V8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.75 12.75L11.75 12.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const mcpIcon = `<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M11.0533 2.79347C12.4449 1.40182 14.7017 1.40188 16.0933 2.79347L16.2193 2.92628C16.9519 3.73696 17.2448 4.80308 17.1002 5.81886C18.1172 5.67274 19.1848 5.96602 19.9966 6.69972L20.1294 6.82569L20.1714 6.86769L20.2974 7.0005C21.5615 8.3994 21.5197 10.5595 20.1714 11.9077L12.8785 19.2007C12.786 19.2935 12.7858 19.444 12.8785 19.5366L14.3755 21.0337C14.6538 21.312 14.6538 21.7632 14.3755 22.0415C14.0972 22.3196 13.646 22.3198 13.3677 22.0415L11.8707 20.5444C11.2213 19.8951 11.2215 18.8423 11.8707 18.1929L19.1627 10.8999C19.9456 10.1171 19.9952 8.87744 19.3101 8.03761L19.1627 7.8755L19.1207 7.83351C18.2856 6.99932 16.932 6.99885 16.0972 7.83351L10.0914 13.8394C10.085 13.8458 10.0765 13.8499 10.0699 13.856L10.0035 13.9234C9.72519 14.2014 9.27393 14.2014 8.99566 13.9234C8.71756 13.6451 8.71763 13.1939 8.99566 12.9155L15.0855 6.82569C15.9205 5.99069 15.9205 4.63629 15.0855 3.80128C14.2505 2.96644 12.8961 2.96629 12.0611 3.80128L3.99761 11.8648C3.71926 12.143 3.2681 12.1431 2.9898 11.8648C2.71179 11.5864 2.71167 11.1352 2.9898 10.8569L11.0533 2.79347Z" fill="currentColor"/><path d="M13.0777 4.80909C13.356 4.53092 13.8072 4.53098 14.0855 4.80909C14.3638 5.0874 14.3637 5.53856 14.0855 5.81691L8.12164 11.7808C7.28687 12.6156 7.28712 13.9691 8.12164 14.8042C8.95667 15.6392 10.311 15.6392 11.146 14.8042L17.1099 8.84132C17.3882 8.56315 17.8394 8.56321 18.1177 8.84132C18.3956 9.11965 18.3958 9.57091 18.1177 9.84913L12.1539 15.813C10.7622 17.2045 8.50553 17.2044 7.11382 15.813C5.72238 14.4213 5.72225 12.1646 7.11382 10.773L13.0777 4.80909Z" fill="currentColor"/></svg>`;
const aiScriptsIcon = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 11C10 9.89543 10.8954 9 12 9H20C21.1046 9 22 9.89543 22 11V19C22 20.1046 21.1046 21 20 21H12C10.8954 21 10 20.1046 10 19V11ZM15.4142 19H20V18.4142L18 16.4142L15.4142 19ZM20 15.5858L19.4142 15C18.6332 14.219 17.3668 14.219 16.5858 15L12.5858 19H12V11H20V15.5858Z" fill="currentColor"/><path d="M15.5 13.25C15.5 13.9404 14.9404 14.5 14.25 14.5C13.5596 14.5 13 13.9404 13 13.25C13 12.5596 13.5596 12 14.25 12C14.9404 12 15.5 12.5596 15.5 13.25Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1 5C1 3.89543 1.89543 3 3 3H9C10.1046 3 11 3.89543 11 5C11 5.55228 10.5523 6 10 6C9.44772 6 9 5.55228 9 5H7V12C7.55228 12 8 12.4477 8 13C8 13.5523 7.55228 14 7 14H5C4.44772 14 4 13.5523 4 13C4 12.4477 4.44772 12 5 12V5H3C3 5.55228 2.55228 6 2 6C1.44772 6 1 5.55228 1 5Z" fill="currentColor"/><path d="M20.7552 2.15769C20.6501 1.94744 20.35 1.94744 20.2449 2.15769C19.5905 3.46646 19.4665 3.5905 18.1577 4.24488C17.9474 4.35001 17.9474 4.65005 18.1577 4.75518C19.4665 5.40956 19.5905 5.5336 20.2449 6.84237C20.35 7.05262 20.6501 7.05262 20.7552 6.84237C21.4096 5.5336 21.5336 5.40956 22.8424 4.75518C23.0526 4.65005 23.0526 4.35001 22.8424 4.24488C21.5336 3.5905 21.4096 3.46646 20.7552 2.15769Z" fill="currentColor"/><path d="M15.2645 4.16345C15.1555 3.94552 14.8445 3.94552 14.7355 4.16345C14.2499 5.13469 14.1347 5.24991 13.1635 5.73553C12.9455 5.8445 12.9455 6.1555 13.1635 6.26447C14.1347 6.75009 14.2499 6.86532 14.7355 7.83655C14.8445 8.05448 15.1555 8.05448 15.2645 7.83655C15.7501 6.86532 15.8653 6.75009 16.8365 6.26447C17.0545 6.1555 17.0545 5.8445 16.8365 5.73553C15.8653 5.24991 15.7501 5.13468 15.2645 4.16345Z" fill="currentColor"/><path d="M4.75514 16.1577C4.65002 15.9474 4.34998 15.9474 4.24486 16.1577C3.59048 17.4664 3.46644 17.5905 2.15769 18.2449C1.94744 18.35 1.94744 18.65 2.15769 18.7551C3.46644 19.4095 3.59048 19.5336 4.24486 20.8423C4.34998 21.0526 4.65002 21.0526 4.75514 20.8423C5.40952 19.5336 5.53356 19.4095 6.84231 18.7551C7.05256 18.65 7.05256 18.35 6.84231 18.2449C5.53356 17.5905 5.40952 17.4664 4.75514 16.1577Z" fill="currentColor"/></svg>`;
const multiplayerIcon = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" x="256" y="256" class="iconify iconify--ion" viewBox="0 0 512 512"><path stroke-width="1.5" fill="currentColor" d="M483.13 245.38C461.92 149.49 430 98.31 382.65 84.33A107.13 107.13 0 0 0 352 80c-13.71 0-25.65 3.34-38.28 6.88C298.5 91.15 281.21 96 256 96s-42.51-4.84-57.76-9.11C185.6 83.34 173.67 80 160 80a115.74 115.74 0 0 0-31.73 4.32c-47.1 13.92-79 65.08-100.52 161C4.61 348.54 16 413.71 59.69 428.83a56.62 56.62 0 0 0 18.64 3.22c29.93 0 53.93-24.93 70.33-45.34c18.53-23.1 40.22-34.82 107.34-34.82c59.95 0 84.76 8.13 106.19 34.82c13.47 16.78 26.2 28.52 38.9 35.91c16.89 9.82 33.77 12 50.16 6.37c25.82-8.81 40.62-32.1 44-69.24c2.57-28.48-1.39-65.89-12.12-114.37ZM208 240h-32v32a16 16 0 0 1-32 0v-32h-32a16 16 0 0 1 0-32h32v-32a16 16 0 0 1 32 0v32h32a16 16 0 0 1 0 32Zm84 4a20 20 0 1 1 20-20a20 20 0 0 1-20 20Zm44 44a20 20 0 1 1 20-19.95A20 20 0 0 1 336 288Zm0-88a20 20 0 1 1 20-20a20 20 0 0 1-20 20Zm44 44a20 20 0 1 1 20-20a20 20 0 0 1-20 20Z"></path></svg>`;
const apiAccessIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C15.498 20.25 18.4875 18.073 19.6876 15M3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C15.498 3.75 18.4875 5.92698 19.6876 9M3.75 12H1.75M17.25 12C17.25 14.8995 14.8995 17.25 12 17.25C9.10051 17.25 6.75 14.8995 6.75 12C6.75 9.10051 9.10051 6.75 12 6.75C14.8995 6.75 17.25 9.10051 17.25 12ZM17.25 12H22.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const seatsIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M3.28125 19.25C2.43556 19.25 1.75 18.5644 1.75 17.7188C1.75 14.6984 4.32436 12.25 7.5 12.25C10.6756 12.25 13.25 14.6984 13.25 17.7188C13.25 18.5644 12.5644 19.25 11.7187 19.25H3.28125Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.75 18.25H20.25C21.3546 18.25 22.2838 17.3456 22.0899 16.2582C21.6564 13.8272 20.302 12.25 17.5357 12.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="7.5" cy="8.5" r="3.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="17.5" cy="9.5" r="2.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const infoIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12 9C11.6227 9 11.2926 9.2086 11.1215 9.52152C10.8565 10.0061 10.2488 10.184 9.76427 9.91899C9.27973 9.65396 9.10178 9.04632 9.3668 8.56178C9.87463 7.63331 10.8626 7 12 7C13.5148 7 14.5669 8.00643 14.8664 9.189C15.1676 10.3779 14.7101 11.763 13.3416 12.4472C13.1323 12.5519 13 12.7659 13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13C11 12.0084 11.5603 11.1018 12.4472 10.6584C12.902 10.431 13.0188 10.0397 12.9277 9.6801C12.835 9.31417 12.5283 9 12 9ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" fill="currentColor"/></svg>`;

function createTooltip(content) {
	return {
		icon: infoIcon,
		content: content,
		html: true,
		triggers: ['click'],
		autoHide: true,
	};
}

function createTooltipLink(href, label) {
	return `<a href="${href}" class="tooltip-link">${label}</a>`;
}

const aiScriptRows = scripts.map((script) => {
	return {
		label: script.key,
		getValue: function () {
			return {
				type: 'check',
			};
		},
	};
});

export const pricingSummaryIcons = {
	swipefile: swipefileIcon,
	brandTracker: brandTrackerIcon,
	seats: seatsIcon,
	multiplayer: multiplayerIcon,
	aiScripts: aiScriptsIcon,
	apiAccess: apiAccessIcon,
	mcp: mcpIcon,
	whitelabelShareLinks: mcpIcon,
};

export const planCategories = [
	{
		name: 'Brand Tracker',
		features: [
			'Track brands',
			'Get insights on tracked brands',
			'Save scraped brand ads directly from Swipekit',
		],
	},
	{
		name: 'Save Ads',
		features: [
			'Save Unlimited Ads',
			'Save Ads from the Facebook Ad library',
			'Save content from Instagram feed',
			'Save content from Tiktok',
			'Save Ads from Tiktok Creative Center',
			'Save Ads from Tiktok Ad Library',
			'Save Ads from the Linkedin Ad Library',
		],
	},
	{
		name: 'Discover winning Ads',
		features: [
			'Access Swipekit multiplayer(over 1M Ads)',
			'Track how long Ads are running(Facebook only)',
			'View Ad Transcript',
		],
	},
	{
		name: 'Organize your library',
		features: ['Create & share unlimited boards', 'Share unlimited Ads'],
	},
	{
		name: 'Other',
		features: ['Priority support(via in-app chat widget)'],
	},
];

export const pricingCards = [
	{
		name: 'Basic plan',
		description:
			'Best for solo marketers and freelancers looking for a reliable swipe tool',
		trackerLimit: 5,
		seats: 5,
		aiCredits: 150,
		features: [
			'Track brands',
			'Get insights on tracked brands',
			'Save scraped brand ads directly from Swipekit',
			'Save Unlimited Ads',
			'Save Ads from the Facebook Ad library',
			'Save content from Instagram feed',
			'Save content from Tiktok',
			'Save Ads from Tiktok Creative Center',
			'Save Ads from Tiktok Ad Library',
			'Save Ads from the Linkedin Ad Library',
			'Access Swipekit multiplayer(over 1M Ads)',
			'Track how long Ads are running(Facebook only)',
			'Create & share unlimited boards',
			'Share unlimited Ads',
			'View Ad Transcript',
		],
	},
	{
		name: 'Plus plan',
		description: 'Best for small brands and up-coming store owners',
		trackerLimit: 10,
		seats: 10,
		aiCredits: 400,
		features: [
			'Track brands',
			'Get insights on tracked brands',
			'Save scraped brand ads directly from Swipekit',
			'Save Unlimited Ads',
			'Save Ads from the Facebook Ad library',
			'Save content from Instagram feed',
			'Save content from Tiktok',
			'Save Ads from Tiktok Creative Center',
			'Save Ads from Tiktok Ad Library',
			'Save Ads from the Linkedin Ad Library',
			'Access Swipekit multiplayer(over 1M Ads)',
			'Track how long Ads are running(Facebook only)',
			'Create & share unlimited boards',
			'Share unlimited Ads',
			'View Ad Transcript',
			'Priority support(via in-app chat widget)',
		],
	},
	{
		name: 'Agency plan',
		description:
			'Best for Agencies, bigger brands & store owners looking to find and generate high performance creatives.',
		trackerLimit: 15,
		seats: 15,
		aiCredits: 1000,
		features: [
			'Track brands',
			'Get insights on tracked brands',
			'Save scraped brand ads directly from Swipekit',
			'Save Unlimited Ads',
			'Save Ads from the Facebook Ad library',
			'Save content from Instagram feed',
			'Save content from Tiktok',
			'Save Ads from Tiktok Creative Center',
			'Save Ads from Tiktok Ad Library',
			'Save Ads from the Linkedin Ad Library',
			'Access Swipekit multiplayer(over 1M Ads)',
			'Track how long Ads are running(Facebook only)',
			'Create & share unlimited boards',
			'Share unlimited Ads',
			'View Ad Transcript',
			'Priority support(via in-app chat widget)',
		],
	},
];

export const comparisonSections = [
	{
		name: 'Access & Limits',
		rows: [
			{
				label: 'Brand Tracker',
				getValue: function (card) {
					return `${card.trackerLimit}`;
				},
			},
			{
				label: 'Seats',
				getValue: function (card) {
					return `${card.seats}`;
				},
			},
			{
				label: 'AI credits',
				getValue: function (card) {
					return `${card.aiCredits}`;
				},
			},
			{
				label: 'MCP',
				tooltip: createTooltip(
					`Connect your Swipekit account to chat apps like ChatGPT and Claude so you can research ads, boards, and patterns without leaving your conversation.<br>${createTooltipLink(
						'/features#mcp-server',
						'View MCP feature'
					)}`
				),
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
			{
				label: 'API',
				tooltip: createTooltip(
					`Pull data directly from your Swipekit account and use it to power internal workflows, dashboards, reporting, and custom tooling.<br>${createTooltipLink(
						'/api',
						'View API docs'
					)}`
				),
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
			{
				label: 'Whitelabel share links',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
		],
	},
	{
		name: 'Ad Research & Inspiration',
		tooltip: createTooltip(
			`Save ads and organic content from the libraries you already use with the Swipekit Chrome extension. Everything you save stays available for future research and reuse.`
		),
		rows: [
			{
				label: 'Ad Saving Chrome Extension',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
			{
				label: 'Meta Ad Library',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
			{
				label: 'Instagram Organic',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
			{
				label: 'TikTok Ad Library & Top Ads',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
			{
				label: 'TikTok Organic',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
			{
				label: 'LinkedIn Ad Library',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
		],
	},
	{
		name: 'Swipefile',
		icon: swipefileIcon,
		tooltip: createTooltip(
			`Build a long-term library of winning ads you can share across your team. Boards, tags, and folders are included so your swipefile stays organized as it grows.<br>${createTooltipLink(
				'/swipefile',
				'Explore Swipefile'
			)}`
		),
		rows: [
			{
				label: 'Swipe File',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
			{
				label: 'Organize Folders & Boards',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
			{
				label: 'Live Ad Active Status',
				tooltip: createTooltip(
					`Every 2 to 3 days, Swipekit rechecks saved Meta ads to see whether they are still active. This makes it easier to spot ads that have been running longer, which is often a strong performance signal.`
				),
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
			{
				label: 'Advanced Sort & Filtering',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
			{
				label: 'Manual Upload',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
			{
				label: 'Automated Transcription',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
		],
	},
	{
		name: 'Multiplayer',
		icon: multiplayerIcon,
		tooltip: createTooltip(
			`Browse community ads inside Swipekit and save the strongest examples straight into your own library.`
		),
		rows: [
			{
				label: '1.5M Ad Library',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
			{
				label: 'Sort by Longest Running Ads',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
			{
				label: 'Ad Transcripts',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
			{
				label: 'Advanced Filtering',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
		],
	},
	{
		name: 'Brand Tracker',
		icon: brandTrackerIcon,
		tooltip: createTooltip(
			`Track brands on the Meta Ad Library without having to recheck it yourself. Swipekit saves newly launched ads daily and generates insights like media mix and landing page destinations.<br>${createTooltipLink(
				'/brand-tracker',
				'Explore Brand Tracker'
			)}`
		),
		rows: [
			{
				label: '24/7 Competitor Meta Ad Tracking',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
			{
				label: 'Media Mix Analysis',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
			{
				label: 'Creative Timeline View',
				getValue: function () {
					return {
						type: 'check',
					};
				},
			},
		],
	},
	{
		name: 'AI Scripts',
		icon: aiScriptsIcon,
		tooltip: createTooltip(
			`Use AI Scripts to quickly turn saved ads into copy, concepts, and storyboards so your team can move faster from research to production.<br>${createTooltipLink(
				'/ai-scripts',
				'Explore AI Scripts'
			)}`
		),
		rows: aiScriptRows,
	},
];

export function getPlanDisplayName(name) {
	return name.replace(' plan', '');
}
